import React, { useState } from "react";
import { ReactComponent as SocialLinkIc } from "../../assets/svg/socialMed_lic_ic.svg";
import { ReactComponent as ServiceSettIc } from "../../assets/svg/service_set_ic.svg";
import { ReactComponent as ArrowIc } from "../../assets/svg/arrow_right_ic.svg";
import { ReactComponent as PartnerIc } from "../../assets/svg/parnter_ics.svg";
import { ReactComponent as CopyIc } from "../../assets/svg/copy_ics_a.svg";
import { ReactComponent as IndustryIC } from "../../assets/svg/industry_icsd.svg";
import { ReactComponent as ProductIc } from "../../assets/svg/products_ics.svg";
import { ReactComponent as TeamsIc } from "../../assets/svg/team_ics.svg";
import { ReactComponent as PhoneIc } from "../../assets/svg/phone_emil_l.svg";
import { ReactComponent as EmailIC } from "../../assets/svg/email_ics_l.svg";
import { ReactComponent as PersonIc } from "../../assets/svg/person_dir_ic.svg";
import { ReactComponent as LocationIc } from "../../assets/svg/location_ics.svg";
import { ReactComponent as LinkIC } from "../../assets/svg/link_icon.svg";
import { ReactComponent as WebsiteEditIC } from "../../assets/svg/website-edit-icon.svg";
import { ReactComponent as Delete } from "../../assets/svg/delete-po.svg";
import { ReactComponent as JobIc } from "../../assets/svg/job_ic.svg";
import { ReactComponent as CareersIc } from "../../assets/svg/careers_ic.svg";
import { ReactComponent as ClientsIc } from "../../assets/svg/clients_ic.svg";
import { ReactComponent as PeoplesIc } from "../../assets/svg/peoples_ic.svg";
import WebSiteEditModal from "../common/website-edit-model";
import WebSiteSearchModal from "../common/website-search-model";

const WebsiteDetailsWidget = ({
  webScrapDetails = {},
  sections = [],
  socialLinks = [],
  serviceList = [],
  industriesList = [],
  productsList = [],
  teamList = [],
  partnerList = [],
  payLinkDetails = {},
  payLinkList = [],
  aboutList = [],
  clientList = [],
  peopleList = [],
  careersList = {},
  teamGrid = 3,
  sourcePage = "create",
  onWebsiteSubmit,
  onWebsiteDelete,
  enableDelete = true,
}) => {
  const [activeWebsiteTab, setActiveWebsiteTab] = useState("Details");
  const [showAlert, setShowAlert] = useState(false);
  const [showWebSiteEditModal, openWebsiteEditModal] = useState(false);
  const [websiteUrl, setWebSite] = useState("");
  const [showWebSiteModal, openWebsiteModal] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 2000);
  };

  // filter tabs with valid values
  const validTabs = sections.filter(
    (item) =>
      item.value &&
      (Array.isArray(item.value)
        ? item.value.length > 0
        : typeof item.value === "object"
          ? Object.keys(item.value).length > 0
          : item.value?.trim?.() !== ""),
  );

  return (
    <div>
      <WebSiteSearchModal
        open={showWebSiteModal}
        website={websiteUrl}
        onEdit={() => {
          openWebsiteEditModal(true);
          openWebsiteModal(false);
        }}
        onClose={() => {
          openWebsiteModal(false);
        }}
        onDataSubmit={(url, webScrapDetails) => {
          openWebsiteModal(false);
          onWebsiteSubmit(url, webScrapDetails);
        }}
      />
      <WebSiteEditModal
        open={showWebSiteEditModal}
        editUrl={webScrapDetails.url}
        onClose={() => openWebsiteEditModal(false)}
        onSubmit={(isSearch, websiteUrl) => {
          if (isSearch && websiteUrl) {
            setWebSite(websiteUrl);
            openWebsiteModal(true);
            openWebsiteEditModal(false);
          }
        }}
        website={websiteUrl}
      />

      {Object.keys(webScrapDetails).length > 0 && sourcePage == "create" && (
        <div
          style={{
            fontWeight: 600,
            fontSize: 16,
            color: "#172B4D",
            marginBottom: 8,
          }}
        >
          Website Information
        </div>
      )}

      {Object.keys(webScrapDetails).length > 0 && sourcePage == "view" && (
        <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 16,
              color: "#172B4D",
              marginBottom: 20,
            }}
          >
            Company overview
          </div>
          <div
            style={{
              height: "4px",
              width: "4px",
              backgroundColor: "#D9D9D9",
              borderRadius: "4px",
              marginTop: "10px",
            }}
          ></div>
          <div
            style={{
              fontWeight: 600,
              fontSize: 16,
              color: "#172B4D",
              marginBottom: 20,
              padding: "4px 12px",
              backgroundColor: "#E9F4FF",
              borderRadius: "100px",
            }}
          >
            <LinkIC />
            <span style={{ color: "#097BED", fontSize: "12px" }}>
              {" "}
              {webScrapDetails.url}
            </span>
          </div>

          {enableDelete === true && (
            <>
              <WebsiteEditIC
                onClick={() => openWebsiteEditModal(true)}
                style={{ marginTop: '4px', cursor: "pointer", height: "24px", width: "24px" }}
              />

              <div
                onClick={() => onWebsiteDelete()}
                style={{ cursor: "pointer", marginTop: "3px" }}
              >
                <Delete />
              </div>
            </>
          )}
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {validTabs.map((tab) => (
          <div
            key={tab.label}
            onClick={() => setActiveWebsiteTab(tab.label)}
            style={{
              padding: "12px 16px",
              borderRadius: "100px",
              backgroundColor: "transparent",
              fontWeight: activeWebsiteTab === tab.label ? 600 : 400,
              fontSize: 13,
              height: 32,
              color: activeWebsiteTab === tab.label ? "#3D4AF5" : "#172B4D",
              cursor: "pointer",
              border:
                activeWebsiteTab === tab.label
                  ? "1.3px solid #3D4AF5"
                  : "1.3px solid #E5E5E5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s",
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {/* Tab content */}
      {validTabs.map((sec) => {
        if (activeWebsiteTab !== sec.label) return null;

        switch (sec.label) {
          case "Details":
            return (
              <DetailsTab
                key={sec.label}
                webScrapDetails={webScrapDetails}
                socialLinks={socialLinks}
                aboutList={aboutList}
                sourcePage={sourcePage}
              />
            );

          case "Services":
            return (
              <ServicesTab
                key={sec.label}
                serviceList={serviceList}
                webScrapDetails={webScrapDetails}
              />
            );

          case "Industries":
            return (
              <IndustriesTab key={sec.label} industriesList={industriesList} />
            );

          case "Products":
            return <ProductsTab key={sec.label} productsList={productsList} />;

          case "About":
            return (
              <div
                key={sec.label}
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "16px",
                  padding: "20px",
                  width: "100%",
                }}
              >
                <ul style={{ paddingLeft: 20, margin: 0 }}>
                  {(webScrapDetails?.about ?? aboutList)?.map((about, idx) => (
                    <li key={idx}>{about}</li>
                  ))}
                </ul>
              </div>
            );

          case "Teams":
            return (
              <TeamsTab
                key={sec.label}
                teamList={teamList}
                teamGrid={teamGrid}
              />
            );

          case "Partners":
            return <PartnersTab key={sec.label} partnerList={partnerList} />;

          case "Pages Link":
            return (
              <PagesLinkTab
                key={sec.label}
                payLinkList={payLinkList}
                payLinkDetails={payLinkDetails}
                productCount={productsList.length}
                serviceCount={serviceList.length}
                handleCopy={handleCopy}
                showAlert={showAlert}
              />
            );

          case "Clients":
            return (
              <ClientsTab key={sec.label} clientsList={clientList ?? []} />
            );

          case "People":
            return <PeopleTab key={sec.label} peopleList={peopleList ?? []} />;

          case "Careers":
            return (
              <CareersTab key={sec.label} careersList={careersList ?? {}} />
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

const DetailsTab = ({
  webScrapDetails = {},
  socialLinks = [],
  sourcePage = "",
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Company Info Card */}
      <div
        style={{ backgroundColor: "#F8F8F8", borderRadius: 16, padding: 16 }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            gap: 16,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            borderBottomRightRadius: 4,
            borderBottomLeftRadius: 4,
            padding: 16,
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", width: "100%", gap: 16 }}>
            {/* Logo */}
            <div
              style={{
                width: 76,
                height: 76,
                border: "1px solid #EBEBEB",
                borderRadius: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                overflow: "hidden",
              }}
            >
              {webScrapDetails.image ? (
                <img
                  src={webScrapDetails.image}
                  alt={webScrapDetails.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "100px",
                  }}
                />
              ) : webScrapDetails?.name ? (
                <span
                  style={{ fontSize: 32, fontWeight: 600, color: "#8790A1" }}
                >
                  {webScrapDetails.name.charAt(0)}
                </span>
              ) : (
                <span style={{ fontSize: 32, color: "#8790A1" }}>🏢</span>
              )}
            </div>

            {/* Content Area */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                marginTop: 12,
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  color: "#172B4D",
                  marginBottom: 4,
                }}
              >
                {webScrapDetails.company_name ?? "-"}
              </div>
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 13,
                  color: "#8790A1",
                  marginBottom: 10,
                }}
              >
                {webScrapDetails.industry ?? "-"}
              </div>
            </div>
          </div>

          {/* Contact Row */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              flexWrap: "wrap",
              marginTop: 12,
            }}
          >
            {(webScrapDetails?.emails ?? []).map((email, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0 12px",
                  height: 28,
                  backgroundColor: "#F8F8F8",
                  borderRadius: 100,
                  gap: 8,
                }}
              >
                <EmailIC />
                <span style={{ fontSize: 13, color: "#172B4D" }}>{email}</span>
              </div>
            ))}

            {webScrapDetails?.emails?.length > 0 &&
              webScrapDetails?.phones?.length > 0 && (
                <div
                  style={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    backgroundColor: "#D9D9D9",
                  }}
                />
              )}

            {(webScrapDetails?.phones ?? []).map((phone, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0 12px",
                  height: 28,
                  backgroundColor: "#F8F8F8",
                  borderRadius: 100,
                  gap: 8,
                }}
              >
                <PhoneIc />
                <span style={{ fontSize: 13, color: "#172B4D" }}>{phone}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Directors Section */}
        {webScrapDetails?.owner && (
          <div
            style={{
              marginTop: 6,
              backgroundColor: "#FFFFFF",
              padding: 16,
              borderRadius: 4,
            }}
          >
            <div
              style={{
                fontWeight: 500,
                fontSize: 11,
                color: "#172B4D",
                marginBottom: 12,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <PersonIc /> DIRECTORS
            </div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <div
                style={{
                  height: 43,
                  backgroundColor: "#ECEDFF",
                  padding: "12px 16px",
                  borderRadius: 35,
                  fontSize: 15,
                  fontWeight: 500,
                  color: "#172B4D",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                {webScrapDetails?.owner ?? "-"}
              </div>
            </div>
          </div>
        )}

        {/* Address */}
        {webScrapDetails?.address && (
          <div
            style={{
              marginTop: 6,
              backgroundColor: "#FFFFFF",
              padding: 16,
              borderBottomLeftRadius: 16,
              borderBottomRightRadius: 16,
            }}
          >
            <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "100px",
                  backgroundColor: "#FFE5E5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LocationIc />
              </div>
              <div style={{ fontSize: 13, color: "#172B4D", lineHeight: 1.5 }}>
                {webScrapDetails?.address ?? "-"}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Social Media Links */}
      {socialLinks.length > 0 && (
        <div
          style={{
            borderRadius: 16,
            padding: 16,
            marginTop: 8,
            border: "1px solid #EBEBEB",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              fontSize: 11,
              color: "#172B4D",
              marginBottom: 12,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <SocialLinkIc /> SOCIAL MEDIA LINKS
          </div>
          <div
            style={{
              display: "grid",
              gap: 12,
              gridTemplateColumns:
                sourcePage === "create" ? "repeat(5, auto)" : "repeat(3, auto)",
              alignItems: "center",
            }}
          >
            {socialLinks.map((item, index) => (
              <div
                key={index}
                onClick={() => window.open(item.url, "_blank")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 12px",
                  height: 36,
                  backgroundColor: "#F8F8F8",
                  borderRadius: 100,
                  gap: 8,
                  width: "fit-content",
                  whiteSpace: "nowrap",
                }}
              >
                {item.icon}
                <div
                  style={{ fontSize: 13, fontWeight: 300, color: "#172B4D" }}
                >
                  {item.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ServicesTab = ({ serviceList }) => (
  <div
    style={{
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: 20,
      width: "100%",
      border: "1px solid #E5E5E5",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <ServiceSettIc />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        SERVICES
      </span>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        backgroundColor: "#FAFAFA",
        padding: 16,
        borderRadius: 12,
      }}
    >
      {serviceList?.map((service, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 12,
            borderRadius: 16,
            border: "1px solid #EBEBEB",
            backgroundColor: "#FFFFFF",
            cursor: "pointer",
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 500, color: "#172B4D" }}>
            {service}
          </span>
          <span
            style={{
              width: 24,
              height: 24,
              backgroundColor: "#F6F6F6",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ArrowIc />
          </span>
        </div>
      ))}
    </div>
  </div>
);

const IndustriesTab = ({ industriesList }) => (
  <div
    style={{
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: 20,
      width: "100%",
      border: "1px solid #E5E5E5",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <IndustryIC />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        Industries
      </span>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        backgroundColor: "#FAFAFA",
        padding: 16,
        borderRadius: 12,
      }}
    >
      {industriesList?.map((industry, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px",
            borderRadius: 16,
            backgroundColor: "#FFFFFF",
            border: "1px solid #EBEBEB",
            cursor: "pointer",
            height: 40,
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 500, color: "#172B4D" }}>
            {industry}
          </span>
          <span
            style={{
              width: 24,
              height: 24,
              backgroundColor: "#F6F6F6",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ArrowIc />
          </span>
        </div>
      ))}
    </div>
  </div>
);

const ProductsTab = ({ productsList }) => (
  <div
    style={{
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: 20,
      width: "100%",
      border: "1px solid #E5E5E5",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <ProductIc />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        Products
      </span>
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 16,
      }}
    >
      {productsList.map((product, index) => (
        <div
          key={index}
          style={{
            backgroundColor: index % 2 === 0 ? "#E9F3FF" : "#EEF0FF",
            borderRadius: 18,
            padding: 24,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 160,
          }}
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16,
            }}
          >
            {product.image ? (
              <img
                src={product.image}
                alt={product.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span
                style={{ fontSize: 22, fontWeight: "bold", color: "#0A2FA6" }}
              >
                {product?.charAt(0)}
              </span>
            )}
          </div>
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: "#0A2FA6",
              textAlign: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: 150,
            }}
          >
            {product ?? "-"}
          </div>
        </div>
      ))}
    </div>
  </div>
);

const TeamsTab = ({ teamList, teamGrid }) => (
  <div
    style={{
      backgroundColor: "#F8F8F8",
      borderRadius: 16,
      padding: 20,
      width: "100%",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <TeamsIc />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        TEAMS
      </span>
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(" + teamGrid + ", 1fr)",
        gap: 16,
      }}
    >
      {teamList.map((team, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            padding: 14,
            borderRadius: 12,
            gap: 14,
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              border: "1px solid #E5E8EB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {team.image ? (
              <img
                src={team.image}
                alt="icon"
                style={{ width: 28, height: 28, objectFit: "contain" }}
              />
            ) : (
              <span style={{ fontSize: 20, fontWeight: 700, color: "#0A2FA6" }}>
                {team.charAt(0).toUpperCase()}
              </span>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#172B4D",
                maxWidth: 180,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {team ?? "-"}
            </div>
            {team.members && (
              <div style={{ fontSize: 13, fontWeight: 400, color: "#6B7280" }}>
                {team.members} members
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

const PartnersTab = ({ partnerList }) => (
  <div
    style={{
      backgroundColor: "#F8F8F8",
      borderRadius: 16,
      padding: 20,
      width: "100%",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <PartnerIc />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        PARTNER
      </span>
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 16,
      }}
    >
      {partnerList.map((partner, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#fff",
            borderRadius: 12,
            padding: 14,
            display: "flex",
            alignItems: "center",
            gap: 14,
            cursor: "pointer",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#172B4D" }}>
              {partner}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const ClientsTab = ({ clientsList = [] }) => (
  <div
    style={{
      backgroundColor: "#F8F8F8",
      borderRadius: 16,
      padding: 16,
      width: "100%",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <ClientsIc />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        CLIENTS
      </span>
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 12,
      }}
    >
      {clientsList.map((client, index) => {
        const clientName =
          typeof client === "string" ? client : (client.name ?? "-");
        const clientLogo = typeof client === "string" ? null : client.logo;

        return (
          <div
            key={index}
            style={{
              backgroundColor: "#fff",
              borderRadius: 16,
              padding: 32,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 168,
              boxShadow: "0 2px 4px rgba(16,24,40,0.03)",
            }}
          >
            <div
              style={{
                width: 80,
                height: 48,
                marginBottom: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {clientLogo ? (
                <img
                  src={clientLogo}
                  alt={clientName}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 8,
                    background: "#F8F8F8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 14,
                    fontWeight: 400,
                    color: "#28303F",
                  }}
                >
                  {clientName.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
            <div
              style={{
                marginTop: 8,
                fontSize: 14,
                color: "#172B4D",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              {clientName}
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

const PeopleTab = ({ peopleList = [] }) => (
  <div
    style={{
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: 20,
      width: "100%",
      border: "1px solid #E5E8EB",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 16,
      }}
    >
      <PeoplesIc />
      <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
        PEOPLE
      </span>
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 16,
      }}
    >
      {peopleList.map((person, index) => {
        const name = typeof person === "string" ? person : (person.name ?? "-");
        const role =
          typeof person === "string"
            ? ""
            : (person.role ?? person.designation ?? "");
        const initial = (name || "-").charAt(0).toUpperCase();

        return (
          <div
            key={index}
            style={{
              backgroundColor: "#fff",
              borderRadius: 12,
              padding: 24,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 120,
              boxShadow: "0 2px 4px rgba(16,24,40,0.03)",
              border: "1px solid #F0F2F5",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                backgroundColor: "#F3EEFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <span style={{ fontSize: 20, fontWeight: 700, color: "#6B4AF5" }}>
                {initial}
              </span>
            </div>
            <div
              style={{
                marginTop: 8,
                fontSize: 16,
                color: "#172B4D",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {name}
            </div>
            {role ? (
              <div
                style={{
                  marginTop: 6,
                  fontSize: 13,
                  color: "#8790A1",
                  fontWeight: 400,
                  textAlign: "center",
                }}
              >
                {role}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  </div>
);

const CareersTab = ({ careersList = {} }) => {
  // careersList may be an object { description, openings: [] } or an array of openings
  const description =
    careersList &&
      typeof careersList === "object" &&
      !Array.isArray(careersList)
      ? (careersList.description ?? null)
      : null;
  const jobs = Array.isArray(careersList)
    ? careersList
    : (careersList?.openings ?? []);

  return (
    <div
      style={{
        backgroundColor: "#F8F8F8",
        borderRadius: 16,
        padding: 16,
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 16,
        }}
      >
        <CareersIc />
        <span style={{ fontWeight: 600, fontSize: 11, color: "#172B4D" }}>
          CAREERS
        </span>
      </div>

      {description ? (
        <div
          style={{
            backgroundColor: "#F8F8F8",
            padding: 20,
            borderRadius: 12,
            marginBottom: 18,
          }}
        >
          <div
            style={{
              backgroundColor: "#FFFFFF",
              padding: 18,
              borderRadius: 10,
              color: "#172B4D",
              lineHeight: 1.6,
              fontSize: "13px",
              fontWeight: 400,
            }}
          >
            {description}
          </div>
        </div>
      ) : null}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 16,
        }}
      >
        {(jobs || []).map((job, idx) => {
          const title =
            typeof job === "string" ? job : (job.title ?? job.name ?? "-");
          return (
            <div
              key={idx}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
                borderRadius: 100,
                padding: "10px 16px",
                gap: 12,
                boxShadow: "0 2px 4px rgba(16,24,40,0.03)",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 100,
                  backgroundColor: "#F2F2FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <JobIc />
              </div>
              <div style={{ fontSize: 14, fontWeight: 500, color: "#172B4D" }}>
                {title}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const PagesLinkTab = ({
  payLinkList = [],
  payLinkDetails = {},
  productCount = 0,
  serviceCount = 0,
  handleCopy,
  showAlert,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* Summary Cards */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        {[
          { label: "Total Pages", value: payLinkList.length ?? 0 },
          { label: "Products", value: productCount ?? 0 },
          { label: "Services", value: serviceCount ?? 0 },
        ].map((item, idx) => (
          <div
            key={idx}
            style={{
              backgroundColor: "#FAFAFA",
              borderRadius: 16,
              padding: "20px 28px",
              width: 200,
              height: 90,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 400,
                color: "#6B7280",
                marginBottom: 10,
              }}
            >
              {item.label}
            </div>
            <div style={{ fontSize: 24, fontWeight: 700, color: "#172B4D" }}>
              {item.value}
            </div>
          </div>
        ))}
      </div>

      {/* List of Page Links */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {showAlert && (
          <div
            style={{
              position: "fixed",
              top: 20,
              right: 20,
              background: "#4CAF50",
              color: "white",
              padding: "10px 16px",
              borderRadius: 8,
              fontSize: 14,
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              zIndex: 9999,
            }}
          >
            Copied!
          </div>
        )}
        {payLinkList.map((link, index) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F4F5FF",
              borderRadius: "50px",
              padding: "14px 18px",
              width: "100%",
              gap: "14px",
              height: "42px",
            }}
          >
            {/* Left label */}
            <div
              title={extractPageName(link)}
              style={{
                fontSize: "15px",
                fontWeight: "500",
                color: "#172B4D",
                minWidth: "90px",
                flex: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {extractPageName(link)}
            </div>

            {/* Vertical Divider */}
            <div
              style={{
                width: "2px",
                height: "42px",
                backgroundColor: "#FFFFFF",
              }}
            ></div>

            {/* URL section */}
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                flex: 4,
                fontSize: "14px",
                fontWeight: "400",
                color: "#3D4AF5",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              {link}
            </a>

            {/* Copy Icon Button */}
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Copy icon button */}
              <div
                onClick={() => handleCopy(link, index)}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50px",
                  backgroundColor: "#ffffff",
                  border: "1px solid #E5E8EB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <CopyIc width={14} height={14} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const extractPageName = (url) => {
  if (!url) return "-";

  try {
    const path = url
      .replace(/https?:\/\//, "")
      .split("/")
      .slice(1)
      .join("/");
    const lastSegment = path.split("/").pop();

    if (!lastSegment) return "Home";

    return lastSegment
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Title Case
  } catch {
    return "-";
  }
};

export default WebsiteDetailsWidget;
